export default "__VITE_ASSET__DsWtJloE__"